<button
    class="btn btn-circle"
    type="button"
    [title]="title()"
    [ariaLabel]="ariaLabel()"
    [class]="[iconClass(), btnClass(), colorClass(), hoverClass()]"
    (click)="clicked.emit()"
></button>
